import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Tabs, Tab } from '@mui/material';
import GroupeddOfferLists from './organisms/GroupedOfferLists';
var TabValues = ['active', 'preparing', 'expired'];
var RoasterOfferLists = function () {
    var t = useTranslation().t;
    var _a = React.useState('active'), tab = _a[0], setTab = _a[1];
    var handleTabChange = React.useCallback(function (_event, value) {
        if (!TabValues.includes(value))
            return;
        setTab(value);
    }, []);
    return (React.createElement(Card, { sx: { mb: 5 } },
        React.createElement(Tabs, { value: tab, onChange: handleTabChange, sx: {
                backgroundColor: function (theme) { return theme.customPalette.background.neutral; },
                px: 3,
            } },
            React.createElement(Tab, { label: t('labels.activeOfferLists'), value: "active" }),
            React.createElement(Tab, { label: t('labels.preparingOfferLists'), value: "preparing" }),
            React.createElement(Tab, { label: t('labels.expiredOfferLists'), value: "expired" })),
        React.createElement(GroupeddOfferLists, { status: tab })));
};
export default RoasterOfferLists;
